
import { Capacitor } from '@capacitor/core';

class Platform {

    static isMobile() {
        return Capacitor.isNativePlatform();
    }

    static isIos() {
        return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';
    }

    static isIosWeb() {
        return (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);
    }

    static isAndroidWeb() {
        return (/android/i.test(navigator.userAgent)); 
    }

}

export default Platform;
